module.exports = __webpack_public_path__ + "img/cover1-1920.c0546858.jpg";